import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors } from '../utils';

const getBorderColor = props => {
  if (props.error) {
    return colors.r01;
  }

  return colors.g03;
};

const Form = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 20px;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Label = styled.p`
  color: ${colors.g05};
  display: flex;
  flex: 1;
  font-size: 16px;
  font-weight: bold;
  justify-content: left;
  margin-bottom: 8px;
  margin-top: 8px;
`;

export const InputComponent = styled.input`
  background-color: ${colors.w01};
  border: 1px solid ${props => getBorderColor(props)};
  border-radius: 4px;
  color: ${colors.g05};
  font-size: 16px;
  height: 40px;
  padding: 0 12px;
  width: 100%;

  :focus {
    outline: none;
  }

  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${colors.g03};
  }
`;

const ErrorMessage = styled.p`
  color: ${colors.r01};
  display: block;
  font-size: 12px;
  margin-bottom: 0;
  margin-top: 8px;
`;

function renderLabel(label, type) {
  if (type === 'password' || !label) {
    return null;
  }

  return <Label>{label}</Label>;
}

function Input({
  error,
  errorText,
  label,
  placeholder,
  type,
  onChange,
  onBlur,
  onFocus,
  autoFocus
}) {
  const [value, setValue] = useState('');

  return (
    <Form>
      {renderLabel(label, type)}

      <InputComponent
        autoFocus={autoFocus}
        error={error}
        onBlur={() => onBlur && onBlur()}
        onChange={event => {
          setValue(event.target.value);
          onChange(event.target.value);
        }}
        onFocus={() => onFocus && onFocus()}
        placeholder={placeholder}
        type={type}
        value={value}
      />

      {error && <ErrorMessage error={error}>{errorText}</ErrorMessage>}
    </Form>
  );
}

Input.defaultProps = {
  autoFocus: false,
  error: false,
  errorText: '',
  label: '',
  onBlur: null,
  onChange: () => {},
  onFocus: null,
  type: 'text'
};

Input.propTypes = {
  autoFocus: PropTypes.bool,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  label: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string
};

export { Input };
